import React, {Component} from 'react';
import {Button, Form, FormControl, FormGroup, InputGroup, Row} from 'react-bootstrap';
import {fetch_teams} from '../../views/BrandKit/actions';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import InfiniteScroll from "react-infinite-scroll-component";
import {add_fonts} from './utils.js';

import {Fetch} from '../../utils';

const { feline_fetch } = Fetch;

const PageSize = 20;

class FontsPanel extends Component {

	constructor(props) {
		super(props);
		this.state = {
			fonts : [],
			data : [],
			bkFonts: [],
			page : 0,
			searchActive: false,
			searchKeywords : ''
		}
	}


	componentDidMount() {
		this.fetchFonts();
		this.populate_bk_fonts();
	}


    fetch_more_fonts = () => {
    	const curr_page = this.state.page;
        const data = this.state.fonts.slice(curr_page*PageSize, (curr_page+1)*PageSize);
        add_fonts(data)
        this.setState({
            data : this.state.data.concat(data),
            page : this.state.page + 1      
        })
    }

    fetchSearchResults = () => {
    	if (this.state.searchKeywords == '') {
    		this.setState({
    			data : this.state.fonts.slice(0, 20),
    			page : 0 
    		})
    		return;
    	}
    	const searchResults = this.state.fonts.filter(element => element.name.toLowerCase().startsWith(this.state.searchKeywords.toLowerCase())).slice(this.state.page*PageSize, (this.state.page+1)*PageSize);
    	add_fonts(searchResults)
    	this.setState({
    		data : searchResults,
    		page : this.state.page + 1
    	})
    }

    populate_bk_fonts = async () => {
    	try{
            if(this.props.brandkit_font_sets){
				var final_fonts = this.props.brandkit_font_sets.map(o => {
					return o.fonts;
				})
				final_fonts = window._.flatten(final_fonts)

				final_fonts = final_fonts.map(o => {
					var src = o.src
					if(!src && o.file && o.file.length>0){
						src = o.file[0]
					}
					return {
						src: src,
						name: o.name
					}
				})

				final_fonts = window._.uniqBy(final_fonts,o => o.src);

				this.setState({bkFonts: final_fonts});
            }else{
                return Promise.resolve(null)
            }
        }catch(error) {
            return Promise.reject(error);
        }
    }

	fetchFonts = () => {
		const numFonts = Math.ceil(window.screen.availHeight/50);

        fetch(global.config.server_path+'design_resource/get/', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({'type':'font',page_no:0,size:1000})})
        .then(resp => resp.json())
        .then((resp) => {
        	let fetched_fonts =  resp.data.docs.sort(function(a,b){
				if(a.name < b.name) { return -1; }
				if(a.name > b.name) { return 1; }
				return 0
			});

    		add_fonts(fetched_fonts.slice(0, numFonts));
            this.setState({
                fonts: fetched_fonts,
				data : fetched_fonts.slice(0, numFonts),
				page  :this.state.page + 1
            });
        })
        .catch(err => console.log(err))
	};

	searchFieldOnChange = (e) => {
		this.setState({
			searchKeywords : e.target.value,
			page : 0
		}, this.fetchSearchResults)
	}

	render() {
		return (
			<React.Fragment>
				<div className="nav_content_search_container" style={{padding: 12, paddingTop: 20}}>
		            <Form onSubmit={this.fetchSearchResults}>
		                <FormGroup>
		                    <InputGroup style={{width: "100%"}}>
		                        <FormControl 
		                        	style={{fontSize: 14, fontFamily: 'Montserrat', height: 42, borderRadius: 4}} 
		                        	placeholder= {'Search fonts'} 
		                        	value={this.state.searchKeywords} 
		                        	type="text" 
		                        	onChange={(e) => this.searchFieldOnChange(e)}/>
		                        {this.state.searchActive ? 
		                            (<span onClick={() => this.setState({searchActive: false, search_text: ''})} style={{cursor: 'pointer', position: 'absolute', right: 12, top: 9, fontSize: 22, zIndex: 100, color: '#C8CDD4'}} className="fas fa-times fa-2x fas-light" />)
		                            : (<span onClick={this.fetchSearchResults} style={{position: 'absolute', cursor: 'pointer', right: 12, top: 9, fontSize: 22, zIndex: 100, color: '#C8CDD4'}} className="fas fa-search fa-2x fas-light" />)
		                        }
		                    </InputGroup>
		                    <Button style={{'display': 'none'}} type='submit'></Button>
		                </FormGroup>
		           </Form>
	            </div>
				<Row style={{ width: "100%", height: "calc(100vh - " + (this.props.external_height ? this.props.external_height : "149px") + ")",overflowY:"auto"}}>
	                {this.state.searchActive ? (
	                <InfiniteScroll
	                        dataLength={this.state.data ? this.state.data.length : 0}
	                        next= {this.fetchSearchResults}
	                        hasMore={true}
	                        endMessage={<h4>No more results.</h4>} 
	                        height={'calc(100vh - 149px)'}
	                >
	                    {this.state.data.map((element, id) => {
	                        const fontCard = (
	                            <div
	                                key={id}
	                                className="font_icon"
	                                style={{cursor: 'pointer', height : '50px',  textAlign: 'left', paddingLeft: 15, paddingTop : 12.5}} 
	                                onClick={((e) => {
	                                    this.props.update_inputs_text({
	                                        value : element.name,
	                                        font_src : element.src
	                                    }, 
	                                    'font')}
	                                )}
	                            >
	                                <span style={{fontFamily: element.name, fontSize : 18}}>{element.name}</span>
	                            </div>
	                        )
	                        return fontCard;
	                    })}
	                </InfiniteScroll>):
	                (<React.Fragment>
	                    {this.state.bkFonts.length>0 && (<hr style={{backgroundColor: '#bbbbbb',borderColor: '#bbbbbb',marginLeft:'10px',marginRight:'10px'}} />)}
	                    {this.state.bkFonts.length>0 && (<p style={{fontWeight: 'bold'}}>Brand Kit</p>)}

	                	{this.state.bkFonts.length>0 && this.state.bkFonts.map((element, id) => {
	                        const font_card = (
	                            <div
	                                key={id}
	                                className="font_icon"
	                                style={{cursor: 'pointer', height : '50px',  textAlign: 'left', paddingLeft: 15, paddingTop : 12.5}} 
	                                onClick={((e) => {
	                                    this.props.update_inputs_text({
	                                        value : element.name,
	                                        font_src : element.src,
	                                        _id: element._id
	                                    }, 
	                                    'font')}
	                                )}
	                            >
	                                <span style={{fontFamily: element.name, fontSize : 18}}>{element.name}</span>
	                            </div>
	                        )
	                        return font_card;
	                    })}
	                    {this.state.bkFonts.length>0 && (<hr style={{backgroundColor: '#bbbbbb',borderColor: '#bbbbbb',marginLeft:'10px',marginRight:'10px'}} />)}
	                	<InfiniteScroll
	                        dataLength={this.state.data ? this.state.data.length : 0}
	                        next= {(() => this.fetch_more_fonts(20))}
	                        hasMore={true}
	                        endMessage={<h4>No more results.</h4>} 
	                        height={'calc(100vh - 149px)'}
		                >
		                    {this.state.data.map((element, id) => {
		                        const font_card = (
		                            <div
		                                key={id}
		                                className="font_icon"
		                                style={{cursor: 'pointer', height : '50px',  textAlign: 'left', paddingLeft: 15, paddingTop : 12.5}} 
		                                onClick={((e) => {
		                                    this.props.update_inputs_text({
		                                        value : element.name,
		                                        font_src : element.src,
		                                        _id: element._id
		                                    }, 
		                                    'font')}
		                                )}
		                            >
		                                <span style={{fontFamily: element.name, fontSize : 18}}>{element.name}</span>
		                            </div>
		                        )
		                        return font_card;
		                    })}
		                </InfiniteScroll>
	                </React.Fragment>)}
	            </Row>
	        </React.Fragment>
		);
	}

}

const mapStateToProps = function(state) {
    return {
        user: state.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetch_teams: () => {
            return dispatch(fetch_teams())
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FontsPanel));